module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "mint-button",
    class: ['mt-btn-' + _vm.type, 'mint-button--' + _vm.size, {
      'is-disabled': _vm.disabled,
      'is-plain': _vm.plain
    }],
    attrs: {
      "type": _vm.nativeType,
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.icon || _vm.$slots.icon) ? _c('span', {
    class: ['mint-button-icon', _vm.size]
  }, [_vm._t("icon", [(_vm.icon) ? _c('i', {
    staticClass: "iconfont",
    class: 'icon-' + _vm.icon,
    style: ({
      'font-size': _vm.iconSize,
      'color': _vm.iconColor
    })
  }) : _vm._e()])], 2) : _vm._e(), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5fb975fb","hasScoped":false,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/button/src/button.vue
// module id = 399
// module chunks = 0